import toast from 'react-hot-toast';

export type NotificationType = 'success' | 'error' | 'info' | 'warning';

export interface Notification {
  id: string;
  type: NotificationType;
  message: string;
  duration?: number;
}

export class NotificationStore {
  constructor() {}

  // Show success notification
  showSuccess(message: string, duration: number = 2000): void {
    toast.success(message, { duration });
  }

  // Show error notification
  showError(message: string, duration: number = 5000): void {
    toast.error(message, { duration });
  }

  // Show info notification
  showInfo(message: string, duration: number = 2000): void {
    toast(message, {
      duration,
      icon: 'ℹ️',
      style: {
        background: '#3B82F6',
        color: '#fff',
      },
    });
  }

  // Show warning notification
  showWarning(message: string, duration: number = 3000): void {
    toast(message, {
      duration,
      icon: '⚠️',
      style: {
        background: '#F59E0B',
        color: '#fff',
      },
    });
  }

  // Generic show method
  show(type: NotificationType, message: string, duration?: number): void {
    switch (type) {
      case 'success':
        this.showSuccess(message, duration);
        break;
      case 'error':
        this.showError(message, duration);
        break;
      case 'info':
        this.showInfo(message, duration);
        break;
      case 'warning':
        this.showWarning(message, duration);
        break;
    }
  }

  // Clear all notifications
  clearAll(): void {
    toast.dismiss();
  }
}

// Export singleton instance
export const notificationStore = new NotificationStore();
